import React from "react";

const CardWrapper = ({ children }) => {
  return (
    <div className="container-fluid select-language-fluid bg-common">
      <div className="container h-100 d-flex align-items-center justify-content-center">
        <div className="row common-card-auth position-relative">{children}</div>
      </div>
    </div>
  );
};

export default CardWrapper;
